module.exports = __webpack_public_path__ + "img/op1.4b20a6d9.jpg";